import { type ComponentPropsWithoutRef, memo } from 'react';
import isEqual from 'react-fast-compare';

import { cn } from '@air/utils-tailwind';

import { useTableView } from '../TableViewContext';
export type TableViewRowProps = ComponentPropsWithoutRef<'div'>;

export const TABLE_ROW_LEFT_PADDING = 16;

export const DesktopTableRowContainer = memo(({ className, style, ...restProps }: TableViewRowProps) => {
  const { getTableWidthStyle } = useTableView();

  return (
    <div
      className={cn(
        'flex-1 [&_.table-cell]:px-2 [&_.table-cell]:py-2 [&_.tableRow]:-mr-4 [&_.tableRow]:rounded-4',
        className,
      )}
      style={{
        marginLeft: `-${TABLE_ROW_LEFT_PADDING}px`,
        ...style,
        ...getTableWidthStyle(),
      }}
      {...restProps}
    />
  );
}, isEqual);

DesktopTableRowContainer.displayName = 'TableViewRow';
